{
  "name": "pregnant-with-diabetes-next",
  "version": "2.86.1",
  "author": "Soren Juul",
  "description": "An app for Pregnant women with Diabetes",
  "homepage": "https://pregnantwithdiabetes.com/",
  "engines": {
    "node": ">=24.15.0 <25",
    "npm": ">=11"
  },
  "type": "module",
  "scripts": {
    "config": "tsx tools/set-env.ts",
    "update:content": "tsx tools/update-content.ts && prettier --write src/app/initial-data/article.data.ts",
    "ng": "ng",
    "start": "ng serve --port $PORT",
    "build": "npm run config && ng build --configuration production",
    "build:vercel": "npm run sentry:ci:vercel:release:start && npm run build && npm run sentry:ci:vercel:release:commits && npm run sentry:ci:vercel && npm run sentry:ci:vercel:release:finish && npm run ngsw:rehash",
    "build:appflow": "npm run sentry:ci:appflow:release:start && CI_BUILD_NUMBER=$(($CI_BUILD_NUMBER + 3000000)) npx trapeze run appflow.yml -y --$CI_PLATFORM && npm run build && npm run sentry:ci:appflow:release:commits && npm run sentry:ci:appflow && npm run sentry:ci:appflow:release:finish && npm run ngsw:rehash",
    "test": "ng test",
    "lint": "eslint && ng lint",
    "start:server": "vercel dev --local",
    "assets": "npx @capacitor/assets generate",
    "sync": "ionic capacitor sync --no-build",
    "sentry:ci:vercel:release:start": "sentry-cli releases new $VERCEL_GITHUB_COMMIT_SHA",
    "sentry:ci:vercel:release:commits": "sentry-cli releases set-commits $VERCEL_GITHUB_COMMIT_SHA --auto --ignore-missing",
    "sentry:ci:vercel:release:finish": "sentry-cli releases finalize $VERCEL_GITHUB_COMMIT_SHA",
    "sentry:ci:appflow:release:start": "sentry-cli releases new $CI_GIT_COMMIT_SHA",
    "sentry:ci:appflow:release:commits": "sentry-cli releases set-commits $CI_GIT_COMMIT_SHA --auto --ignore-missing",
    "sentry:ci:appflow:release:finish": "sentry-cli releases finalize $CI_GIT_COMMIT_SHA",
    "sentry:ci:vercel": "sentry-cli sourcemaps inject --org heyworlddk --project pregnant-app ./www && sentry-cli sourcemaps upload --org heyworlddk --project pregnant-app --release $VERCEL_GITHUB_COMMIT_SHA --dist web ./www",
    "sentry:ci:appflow": "sentry-cli sourcemaps inject --org heyworlddk --project pregnant-app ./www && sentry-cli sourcemaps upload --org heyworlddk --project pregnant-app --release $CI_GIT_COMMIT_SHA --dist $CI_PLATFORM ./www",
    "postinstall": "npm run update:content",
    "checkly:test": "npx checkly test --record",
    "test:e2e": "start-server-and-test start:server http://localhost:3000 \"ENVIRONMENT_URL=http://localhost:3000 playwright test __checks__ --timeout 60000\"",
    "typecheck": "tsc --noEmit",
    "ngsw:rehash": "ngsw-config www/browser ngsw-config.json"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "22.2.2",
    "@angular/core": "22.2.2",
    "@angular/elements": "22.2.2",
    "@angular/forms": "22.2.2",
    "@angular/platform-browser": "22.2.2",
    "@angular/router": "22.2.2",
    "@angular/service-worker": "22.2.2",
    "@capacitor-community/in-app-review": "8.0.0",
    "@capacitor-firebase/analytics": "8.5.2",
    "@capacitor/android": "8.5.3",
    "@capacitor/app": "8.1.2",
    "@capacitor/core": "8.5.3",
    "@capacitor/haptics": "8.0.2",
    "@capacitor/ios": "8.5.3",
    "@capacitor/keyboard": "8.0.6",
    "@capacitor/splash-screen": "8.0.2",
    "@capacitor/status-bar": "8.0.4",
    "@ionic/angular": "9.0.9",
    "@ionic/core": "9.0.9",
    "@ionic/storage": "4.0.0",
    "@ionic/storage-angular": "4.0.0",
    "@ngx-translate/core": "18.0.0",
    "@ngx-translate/http-loader": "18.0.0",
    "@sentry/angular": "10.69.0",
    "@sentry/capacitor": "4.3.0",
    "@sentry/node": "10.69.0",
    "@vercel/analytics": "2.0.1",
    "@vercel/node": "27.0.0",
    "@vercel/speed-insights": "2.0.0",
    "dompurify": "3.4.17",
    "firebase": "12.19.0",
    "rxjs": "7.8.2",
    "tslib": "2.8.1",
    "uuid": "14.0.3"
  },
  "devDependencies": {
    "@angular-eslint/builder": "22.6.0",
    "@angular-eslint/eslint-plugin": "22.6.0",
    "@angular-eslint/eslint-plugin-template": "22.6.0",
    "@angular-eslint/schematics": "22.6.0",
    "@angular-eslint/template-parser": "22.6.0",
    "@angular-eslint/utils": "22.6.0",
    "@angular/build": "22.2.2",
    "@angular/cli": "22.2.2",
    "@angular/compiler-cli": "22.2.2",
    "@angular/language-service": "22.2.2",
    "@capacitor/cli": "8.5.3",
    "@eslint/eslintrc": "3.3.7",
    "@eslint/js": "10.0.1",
    "@ionic/angular-toolkit": "13.0.0",
    "@ionic/cli": "7.2.1",
    "@playwright/test": "1.64.1",
    "@sentry/cli": "3.8.2",
    "@trapezedev/configure": "7.1.11",
    "@types/node": "24.19.2",
    "@typescript-eslint/eslint-plugin": "8.72.0",
    "@typescript-eslint/parser": "8.72.0",
    "@typescript-eslint/utils": "8.72.0",
    "ajv": "8.20.0",
    "angular-eslint": "22.6.0",
    "checkly": "9.5.0",
    "eslint": "10.13.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-prettier": "5.5.7",
    "ionicons": "8.1.0",
    "jsdom": "30.1.3",
    "native-run": "2.0.3",
    "prettier": "3.9.10",
    "start-server-and-test": "3.0.13",
    "tsx": "4.23.15",
    "typescript": "6.0.3",
    "typescript-eslint": "8.72.0",
    "vercel": "65.1.0",
    "vitest": "5.0.5"
  },
  "allowScripts": {
    "@firebase/util@1.15.3": true,
    "@parcel/watcher@2.6.0": true,
    "@sentry/capacitor@4.3.0": true,
    "@sentry/cli@3.8.0": true,
    "esbuild@0.27.7": true,
    "esbuild@0.27.0": true,
    "esbuild@0.28.2": true,
    "lmdb@3.5.6": true,
    "msgpackr-extract@3.0.4": true,
    "protobufjs@7.6.5": true
  }
}
